import { axiosInstance } from "../axios/axiosConfig";

const controller = "BundleDiscounts";

export const getBundleDiscounts = async () => {
  try {
    const response = await axiosInstance.get(`${controller}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
